import { isBreachable, type LevelDef } from './sim/types';
import { simulate } from './sim/simulator';

/** Every tappable starter that wins. Campaign design thesis: exactly one. */
export function winningStarters(level: LevelDef): string[] {
  return level.nodes
    .filter(isBreachable)
    .map((n) => n.id)
    .filter((id) => simulate(level, id).outcome === 'win');
}

/**
 * Starters the rewarded hint may rule out: tappable, LOSING, not yet ruled out.
 * A hint must never touch any winning starter, so a level with several winners
 * (the teaching levels) can never have a winner removed.
 */
export function hintCandidates(level: LevelDef, alreadyOut: Iterable<string> = []): string[] {
  const out = new Set(alreadyOut);
  const win = new Set(winningStarters(level));
  return level.nodes
    .filter(isBreachable)
    .map((n) => n.id)
    .filter((id) => !win.has(id) && !out.has(id));
}
